import moment from "moment";
import React, { useEffect, useState } from "react";
import { Badge, Button, Modal, Pagination, Select, Table } from "flowbite-react";
import { FaArrowsLeftRight } from "react-icons/fa6";
import axios from "../../config/axiosInstance";
import { useQuery, useQueryClient } from "react-query";
import { ADMIN, CATEGORIES } from "../../config/apiConfig";
import { TbLockSearch } from "react-icons/tb";
import CompanyQueriesForm from "../forms/CompanyQueriesForm";
import { IoMdAdd, IoMdSearch } from "react-icons/io";
import { Link, useNavigate } from "react-router-dom";
import { FaFileInvoiceDollar, FaRegEdit } from "react-icons/fa";
import CompanyEditForm from "../forms/CompanyEditForm";
import EmptyTable from "./EmptyTable";
import {
  MdBlock,
  MdFilterListAlt,
  MdOutlineRemoveRedEye,
} from "react-icons/md";
import ModalDelete from "../modals/ModalDelete";
import TableLoading from "../TableLoading";
import { Tooltip } from "react-tooltip";
import CompanyInvoiceForm from "../forms/CompanyInvoiceForm";
import { useForm } from "react-hook-form";
import Input from "../inputs/Input";
import SelectInput from "../inputs/SelectInput";
import AutoCompleteInput from "../inputs/Autocomplete";
import { useApplication } from "../../contexts/ApplicationContext";
import Drawer from "../Drawer";

const AdminCustomersTableSpecific = ({ companyId, isActive }) => {
  const { userPermission } = useApplication();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const onPageChange = (page) => setCurrentPage(page);
  const [searchName, setSearchName] = useState("");
  const [nameParam, setNameParam] = useState("");
  const [isDrawerPermissionQueries, setIsDrawerPermissionQueries] =
    useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [isDrawerViewInvoice, setIsDrawerViewInvoice] = useState(false);
  const [isDrawerEditCustomer, setIsDrawerEditCustomer] = useState(false);
  const [isOpenModalBlock, setOpenModalBlock] = useState(false);
  const [isLoadingBlock, setIsLoadingBlock] = useState(false);
  const [typeBlock, setTypeBlock] = useState(0);
  const [isVisibleFilter, setIsVisibleFilter] = useState(true);
  const [selectedRepresentative, setSelectedRepresentative] = useState({
    label: "Todos os representantes",
    value: "",
  });
  const itemsPerPage = 20;

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    formState: { errors },
  } = useForm();

  const {
    isLoading: isLoadingListCustomers,
    error: errorListCustomers,
    data: listCustomers,
  } = useQuery(
    [
      "listCustomers",
      currentPage,
      nameParam,
      watch("createdAt"),
      watch("status"),
      watch("typePayment"),
      watch("typeCustomer"),
      watch("isIntegrator"),
      companyId,
    ],
    async () => {
      const { data } = await axios.get(
        `${
          ADMIN.GET_CUSTOMERS
        }?page=${currentPage}&search=${nameParam}&createdAt=${watch(
          "createdAt"
        )}&status=${watch("status")}&typeCustomer=${watch(
          "typeCustomer"
        )}&typePayment=${watch("typePayment")}&isIntegrator=${watch(
          "isIntegrator"
        )}&representativeId=${companyId}&itemsPerPage=${itemsPerPage}`
      );

      setTotalPages(data.data.totalPages || 1);
      setTotalCount(data.data.totalCount || 0);

      return data.data.data;
    },
    {
      enabled: isActive,
    }
  );

  const {
    isLoading: isLoadingCategories,
    error: errorCategories,
    data: categories,
  } = useQuery(
    ["categories"],
    async () => {
      const { data } = await axios.get(
        `${CATEGORIES.GET_ALL}?itemsPerPage=${-1}`
      );

      return data.data.data;
    },
    { enabled: isActive }
  );

  const handleSearchName = (e) => {
    e.preventDefault();
    setNameParam(searchName);
  };

  const handleEditPermissionQueries = (company) => {
    setSelectedCompany(company);
    setIsDrawerPermissionQueries((prevState) => !prevState);
  };

  const blockUnlockCustomer = async (type = 0) => {
    try {
      setIsLoadingBlock(true);
      await axios.put(`${ADMIN.GET_COMPANY}/${selectedCompany.id}`, {
        status: type,
      });

      queryClient.invalidateQueries(["listCustomers", currentPage]);
      setOpenModalBlock(false);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoadingBlock(false);
    }
  };

  return (
    <>
      <form onSubmit={handleSearchName} className="">
        <div className="bg-white border border-slate-200 rounded-xl shadow-sm mb-4">
          <div className="flex items-center justify-between gap-3 px-3 py-2 border-b border-slate-200 bg-gray-50">
            <span className="text-xs font-semibold uppercase tracking-wide text-slate-500">
              Filtros Avançados
            </span>
          </div>
          <div
            className={`grid grid-cols-1 md:grid-cols-2 gap-x-3 gap-y-5 px-3 py-3 ${
              userPermission === "POWER_USER"
                ? "lg:grid-cols-2"
                : "lg:grid-cols-2"
            }`}
          >
            <div>
              <Input
                register={register}
                label="Data de cadastro"
                name="createdAt"
                type="date"
              />
            </div>
            <div>
              <SelectInput
                register={register}
                label="Tipo de cliente"
                name="typeCustomer"
              >
                <option value="">Todos os tipos</option>
                <option value="CPF">Física</option>
                <option value="CNPJ">Jurídica</option>
              </SelectInput>
            </div>
            <div>
              <SelectInput
                register={register}
                label="Tipo de pagamento"
                name="typePayment"
              >
                <option value="">Todos os tipos</option>
                <option value="PRE">Pré-Pago</option>
                <option value="POS">Pós-Pago</option>
              </SelectInput>
            </div>
            <div>
              <SelectInput
                register={register}
                label="Status do cliente"
                name="status"
              >
                <option value="">Todos os status</option>
                <option value={1}>Ativo</option>
                <option value={0}>Bloqueado</option>
                <option value={-1}>Inadimplente</option>
              </SelectInput>
            </div>
          </div>
        </div>
        <div className="flex gap-1 w-full pl-3 pr-2 py-2 md:py-1 rounded-md shadow-sm bg-gray-300">
          <input
            type="text"
            placeholder="Busque por nome, telefone, e-mail ou documento do cliente..."
            className="border-0 py-1 text-sm mt-1 focus:outline-none focus:ring-0 focus:border-gray-300 px-0 w-full bg-gray-300 placeholder:text-gray-700"
            onChange={(e) => setSearchName(e.target.value)}
            value={searchName}
          />
          <Button
            size="sm"
            className="flex items-center bg-secondary w-20"
            type="submit"
          >
            <IoMdSearch />
          </Button>
        </div>
      </form>

      {listCustomers?.length > 0 || isLoadingListCustomers ? (
        <>
          <div className="mt-0 md:mt-5">
            {/* Mobile: Cards */}
            <div className="md:hidden p-3 space-y-3">
              {!isLoadingListCustomers ? (
                (listCustomers?.length ?? 0) > 0 ? (
                  listCustomers.map((customer, index) => {
                    const name =
                      customer.typeCustomer === "CPF"
                        ? customer.name
                        : customer.socialReason;
                    const repName = customer?.ParentCompany
                      ? customer?.ParentCompany?.name ||
                        customer?.ParentCompany?.socialReason
                      : "-";
                    const typeLabel =
                      customer.typeCustomer === "CPF" ? "Física" : "Jurídica";
                    const paymentLabel =
                      customer.typePayment === "PRE" ? "Pré-pago" : "Pós-pago";
                    const statusLabel =
                      customer.status === 1
                        ? "Ativo"
                        : customer.status === 0
                        ? "Bloqueado"
                        : "Inadimplente";

                    return (
                      <div
                        key={index}
                        className="rounded-xl border border-gray-200 bg-white p-3 shadow-sm"
                      >
                        <div className="flex items-start justify-between gap-3">
                          <div className="min-w-0">
                            <div
                              className="text-sm font-semibold text-gray-900 truncate"
                              title={name}
                            >
                              {name}
                            </div>
                            <div className="text-xs text-gray-500 truncate">
                              {repName}
                            </div>
                          </div>
                          <span className="text-[11px] text-gray-500">
                            {typeLabel}
                          </span>
                        </div>

                        <div className="mt-2 flex flex-wrap gap-2 text-xs text-gray-600">
                          <span className="rounded-full bg-gray-100 px-2 py-0.5">
                            {paymentLabel}
                          </span>
                          <span className="rounded-full bg-gray-100 px-2 py-0.5">
                            {statusLabel}
                          </span>
                          <span className="rounded-full bg-gray-100 px-2 py-0.5">
                            {moment(customer.createdAt).format("DD/MM/yyyy")}
                          </span>
                        </div>

                        <div className="mt-3 flex items-center gap-2">
                          <Tooltip
                            id={`tooltip-edit-permissions-card-${index}`}
                            content="Editar Permissões"
                          />
                          <button
                            type="button"
                            data-tooltip-id={`tooltip-edit-permissions-card-${index}`}
                            onClick={() => handleEditPermissionQueries(customer)}
                            className="inline-flex items-center gap-1 rounded-md border border-gray-200 px-2 py-1 text-xs text-gray-700 hover:bg-gray-100"
                          >
                            <TbLockSearch className="text-gray-500" />
                            Permissões
                          </button>
                          <Tooltip
                            id={`tooltip-view-customer-card-${index}`}
                            content="Visualizar cliente"
                          />
                          <button
                            type="button"
                            data-tooltip-id={`tooltip-view-customer-card-${index}`}
                            onClick={() =>
                              navigate(`/admin/customers/${customer?.uuid}`, {
                                replace: true,
                              })
                            }
                            className="inline-flex items-center gap-1 rounded-md border border-gray-200 px-2 py-1 text-xs text-gray-700 hover:bg-gray-100"
                          >
                            <MdOutlineRemoveRedEye className="text-gray-500" />
                            Visualizar
                          </button>
                        </div>
                      </div>
                    );
                  })
                ) : null
              ) : (
                Array.from({ length: 4 }).map((_, idx) => (
                  <div
                    key={idx}
                    className="rounded-xl border border-gray-200 bg-white p-3 shadow-sm animate-pulse"
                  >
                    <div className="h-4 bg-gray-100 rounded w-1/2" />
                    <div className="mt-2 h-3 bg-gray-100 rounded w-2/3" />
                    <div className="mt-3 h-3 bg-gray-100 rounded w-1/3" />
                  </div>
                ))
              )}
            </div>

            {/* Desktop: Tabela */}
            <div className="hidden md:block overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
              <div className="overflow-x-auto">
                <Table hoverable striped className="text-xs xl:text-sm">
                  <Table.Head className="sticky top-0 bg-gray-100">
                    <Table.HeadCell className="bg-gray-100">
                      Cliente
                    </Table.HeadCell>
                    <Table.HeadCell className="text-center bg-gray-100">
                      Data cadastro
                    </Table.HeadCell>
                    <Table.HeadCell className="text-center bg-gray-100">
                      Representante
                    </Table.HeadCell>
                    <Table.HeadCell className="text-center bg-gray-100">
                      Tipo
                    </Table.HeadCell>
                    <Table.HeadCell className="text-center bg-gray-100 relative">
                      Tipo de pagamento
                    </Table.HeadCell>
                    <Table.HeadCell className="text-center bg-gray-100">
                      Status
                    </Table.HeadCell>
                    <Table.HeadCell className="text-center bg-gray-100">
                      Ações
                    </Table.HeadCell>
                  </Table.Head>

                  <Table.Body className="divide-y">
                    {!isLoadingListCustomers ? (
                      (listCustomers?.length ?? 0) > 0 ? (
                        listCustomers.map((customer, index) => (
                          <Table.Row
                            key={index}
                            className="bg-white hover:bg-indigo-50/40"
                          >
                            <Table.Cell className="font-medium text-gray-900 py-2">
                              {customer.typeCustomer === "CPF"
                                ? customer.name
                                : customer.socialReason}
                            </Table.Cell>
                            <Table.Cell className="font-medium text-gray-900 text-center py-2">
                              {moment(customer.createdAt).format("DD/MM/yyyy")}
                            </Table.Cell>
                            <Table.Cell className="font-medium text-gray-900 text-center py-2">
                              {customer?.ParentCompany
                                ? `${
                                    customer?.ParentCompany?.name ||
                                    customer?.ParentCompany?.socialReason
                                  }`
                                : "-"}
                            </Table.Cell>
                            <Table.Cell className="font-medium text-gray-900 text-center py-2">
                              {customer.typeCustomer === "CPF"
                                ? "Física"
                                : "Jurídica"}
                            </Table.Cell>
                            <Table.Cell className="text-center py-2">
                              <Badge className="w-fit mx-auto">
                                {customer.typePayment === "PRE"
                                  ? "Pré-pago"
                                  : "Pós-pago"}
                              </Badge>
                            </Table.Cell>
                            <Table.Cell className="text-center py-2">
                              {customer.status === 1 ? (
                                <Badge color="green" className="mx-auto w-fit">
                                  Ativo
                                </Badge>
                              ) : customer.status === 0 ? (
                                <Badge
                                  color="failure"
                                  className="mx-auto w-fit"
                                >
                                  Bloqueado
                                </Badge>
                              ) : (
                                <Badge
                                  color="failure"
                                  className="mx-auto w-fit"
                                >
                                  Inadimplente
                                </Badge>
                              )}
                            </Table.Cell>
                            <Table.Cell className="text-center py-1">
                              <div className="flex gap-2 justify-center items-center">
                                <Tooltip
                                  id={`tooltip-edit-permissions-${index}`}
                                  content="Editar Permissões"
                                />
                                <TbLockSearch
                                  data-tooltip-id={`tooltip-edit-permissions-${index}`}
                                  fontSize="16"
                                  className="text-gray-500 hover:text-gray-800 cursor-pointer transition-colors"
                                  onClick={() =>
                                    handleEditPermissionQueries(customer)
                                  }
                                />
                                <Tooltip
                                  id={`tooltip-view-customer-${index}`}
                                  content="Visualizar cliente"
                                />
                                <MdOutlineRemoveRedEye
                                  data-tooltip-id={`tooltip-view-customer-${index}`}
                                  fontSize="16"
                                  className="text-gray-500 hover:text-gray-800 cursor-pointer transition-colors"
                                  onClick={() =>
                                    navigate(`/admin/customers/${customer?.uuid}`, {
                                      replace: true,
                                    })
                                  }
                                />
                              </div>
                            </Table.Cell>
                          </Table.Row>
                        ))
                      ) : null
                    ) : (
                      <TableLoading cols={7} />
                    )}
                  </Table.Body>
                </Table>
              </div>
            </div>
          </div>

          {totalCount > 0 && (
            <div className="mt-3 text-center text-sm text-gray-600">
              Exibindo {(currentPage - 1) * itemsPerPage + 1}–
              {Math.min(currentPage * itemsPerPage, totalCount)} de {totalCount}{" "}
              registros
            </div>
          )}

          {totalPages > 1 && (
            <div className="flex overflow-x-auto justify-center mt-3">
              <Pagination
                layout="pagination"
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={onPageChange}
                previousLabel=""
                nextLabel=""
                showIcons
              />
            </div>
          )}
        </>
      ) : (
        <EmptyTable icon="person_off">Nenhum cliente cadastrado</EmptyTable>
      )}

      <Drawer
        title={`Visualizar faturamento`}
        onClose={setIsDrawerViewInvoice}
        isOpen={isDrawerViewInvoice}
        className={"w-full md:w-4/6 lg:w-3/6 xl:w-2/6"}
      >
        <CompanyInvoiceForm
          company={selectedCompany}
          onClose={setIsDrawerViewInvoice}
          isDrawerOpen={isDrawerViewInvoice}
          companyType="CUSTOMER"
        />
      </Drawer>

      <Modal
        show={isDrawerPermissionQueries}
        onClose={() => setIsDrawerPermissionQueries(false)}
        size="4xl"
      >
        <Modal.Header>Permissões</Modal.Header>
        <Modal.Body>
          <CompanyQueriesForm
            company={selectedCompany}
            categories={categories}
            onClose={setIsDrawerPermissionQueries}
            fetchCompanies={() =>
              queryClient.invalidateQueries(["listCustomers", currentPage])
            }
          />
        </Modal.Body>
      </Modal>
      <Drawer
        title={`Editar cliente`}
        onClose={setIsDrawerEditCustomer}
        isOpen={isDrawerEditCustomer}
        className={"w-full md:w-4/6 lg:w-3/6"}
      >
        <CompanyEditForm
          company={selectedCompany}
          onClose={setIsDrawerEditCustomer}
          categories={categories}
          fetchCompanies={() =>
            queryClient.invalidateQueries(["listCustomers", currentPage])
          }
        />
      </Drawer>

      <ModalDelete
        title={`Deseja ${
          typeBlock === 0 ? "bloquear" : "desbloquear"
        } este cliente?`}
        isOpen={isOpenModalBlock}
        setOpenModal={setOpenModalBlock}
        isLoading={isLoadingBlock}
        handleDelete={() => blockUnlockCustomer(typeBlock)}
      />
    </>
  );
};

export default AdminCustomersTableSpecific;
